module.exports = __webpack_public_path__ + "static/no-data.686f2081.png";